import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, withStyles } from '@material-ui/core/styles';
import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Authenticate from '../Authenticate/Authenticate';
import Navigator from './Navigator';
import Header from './Header';
import { useTranslation } from "react-i18next";
import i18n from "../../translations/i18n";
import Cookies from 'js-cookie';
import PermissionContext from '../../contexts/PermissionContext';
import UserDataContext from '../../contexts/UserDataContext';
import ConfigContext from '../../contexts/ConfigContext';
import DataService from "../../services/data.service";


function Copyright() {
  const { t } = useTranslation();
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="http://material-ui.com/">
        {t("main_website")}
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

let theme = createMuiTheme({
  palette: {
    primary: {
      light: '#63ccff',
      main: '#009be5',
      dark: '#006db3',
    },
  },
  typography: {
    h5: {
      fontWeight: 500,
      fontSize: 26,
      letterSpacing: 0.5,
    },
  },
  shape: {
    borderRadius: 8,
  },
  props: {
    MuiTab: {
      disableRipple: true,
    },
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
});

theme = {
  ...theme,
  overrides: {
    MuiDrawer: {
      paper: {
        backgroundColor: '#18202c',
      },
    },
    MuiButton: {
      label: {
        textTransform: 'none',
      },
      contained: {
        boxShadow: 'none',
        '&:active': {
          boxShadow: 'none',
        },
      },
    },
    MuiTabs: {
      root: {
        marginLeft: theme.spacing(1),
      },
      indicator: {
        height: 3,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        backgroundColor: theme.palette.common.white,
      },
    },
    MuiTab: {
      root: {
        textTransform: 'none',
        margin: '0 16px',
        minWidth: 0,
        padding: 0,
        [theme.breakpoints.up('md')]: {
          padding: 0,
          minWidth: 0,
        },
      },
    },
    MuiIconButton: {
      root: {
        padding: theme.spacing(1),
      },
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 4,
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: '#404854',
      },
    },
    MuiListItemText: {
      primary: {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    MuiListItemIcon: {
      root: {
        color: 'inherit',
        marginRight: 0,
        '& svg': {
          fontSize: 20,
        },
      },
    },
    MuiAvatar: {
      root: {
        width: 80,
        height: 80,
        marginRight: theme.spacing(1),
      },
    },
  },
};

const drawerWidth = 256;

const styles = {
  root: {
    display: 'flex',
    minHeight: '100vh',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  app: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    padding: theme.spacing(6, 4),
    background: '#eaeff1',
  },
  footer: {
    padding: theme.spacing(2),
    background: '#eaeff1',
  },
};

const getAccessToken = () => Cookies.get('access_token')
    function Error(message) {
        this.message = message;
        this.name = 'UserException';
}


const Main = (props) => {
  const { classes } = props;
  const [language, setLanguage] = useState('es');

  const [mobileOpen, setMobileOpen] = useState(false);
  const [ContentComponent, setContentComponent] = useState(<Authenticate />);
  const [headerTitle, setHeaderTitle] = useState("");



  const handleOnLanguageChangeClick = (e) => {
    // e.preventDefault();        
    setLanguage(e.target.value);
    i18n.changeLanguage(e.target.value)
  }


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };


  const endpointPermission = 'permission';


  const [permissionData, setPermissionData] = useState({})
  useEffect(() => {
    retrieveData()
  }, []);

  const retrieveData = () => {
    DataService.getAll(endpointPermission)
      .then(response => {
        // console.log("main get data ###########", response.data)
        setPermissionData(response.data)
      })
      .catch(e => {
        console.log("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
      });
  }


  const userHasPermission = (permission, permissionType) => {
    // console.log("MAIN",permissionData.path, permission, permissionType);

    try {
      if (permissionData.filter((record) => (record.user.id == userData.id && record.user.is_superuser)).length > 0) {
        return true
      } else {
        return permissionData.filter((record) => record.user.id == userData.id && record.path === permission && record[permissionType] == 1).length > 0;
      }
    } catch {
      // console.log("Error: (maybe credentials expired)", permissionData.path, permission, permissionType);
    }
  };

  const userEndpoint = `users/me`

  const [userData, setUserData] = useState([]);
	useEffect(() => {

		retrieveUserData()
	}, []);

	const retrieveUserData = () => {
		DataService.getAll(userEndpoint)
			.then(response => {
        if (getAccessToken()) {
          // const expires = ( 180 * 60) * 1000
          // const inOneHour = new Date(new Date().getTime() + expires)
          // console.log("user",response.data);
          // you will have the exact same setters in your Login page/app too
          // Cookies.set('UU_IDD', response.data.id, { expires: inOneHour })                    
          setUserData(response.data)          
        }
								
			})
			.catch(e => {
				// openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
        console.log("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
			});
	}

  const configEndpoint = `configuration`

   
    // const {userHasPermission} = useContext(PermissionContext);
    
    // Getting config data only once at the beggining
    const [configData, setConfigData] = useState({});
    useEffect(() => {
  
      retrieveConfigData()
    }, []);
  
    const retrieveConfigData = () => {
      DataService.getAll(configEndpoint)
        .then(response => {
          let configTemp = {};
          response.data.forEach(cfg => {
            configTemp[cfg.config_name] = cfg.config_value
          });
  
          setConfigData(configTemp)
          // console.log(configTemp);      
        })
        .catch(e => {
          console.log(e)
          alert(`Error - Code: ${e.response.status} Message: ${e.response.statusText}`)
        });
    }

  return (
    <ThemeProvider theme={theme}>
      <PermissionContext.Provider value={{userHasPermission}}>
       <UserDataContext.Provider value={{userData}}> 
        <ConfigContext.Provider value={{configData}}> 
        <div className={classes.root}>
          <CssBaseline />
          <nav className={classes.drawer}>
            <Hidden smUp implementation="js">
              <Navigator
                PaperProps={{ style: { width: drawerWidth } }}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                setContentComponent={setContentComponent}
                setHeaderTitle={setHeaderTitle}
              />
            </Hidden>
            <Hidden xsDown implementation="css">
              <Navigator PaperProps={{ style: { width: drawerWidth } }}
                setContentComponent={setContentComponent}
                setHeaderTitle={setHeaderTitle}

              />
            </Hidden>
          </nav>
          <div className={classes.app}>
            <Header
              title={headerTitle}
              onDrawerToggle={handleDrawerToggle}
              language={language}
              handleOnLanguageChangeClick={handleOnLanguageChangeClick}
            />
            <main className={classes.main}>
              {ContentComponent}
            </main>
            <footer className={classes.footer}>
              <Copyright />
            </footer>
          </div>
        </div>
          </ConfigContext.Provider>
        </UserDataContext.Provider>
      </PermissionContext.Provider>
    </ThemeProvider>

  );
}

Main.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Main);